import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";
import Fab from "./Fab";
import AddTransactionSheet from "../AddTransactionSheet";

export default function AppShell() {
  const location = useLocation();
  const [openAdd, setOpenAdd] = useState(false);

  // Hide FAB on screens where "+" does NOT mean "add movement"
  // (causes UX confusion — e.g. on /cuentas users would expect it to add an account)
  const fabHiddenRoutes = [
    "/configuracion",
    "/recurrencias",
    "/historial",
    "/cuentas",
    "/proyeccion",
    "/categorias",
    "/admin",
  ];
  const showFab = !fabHiddenRoutes.includes(location.pathname);

  return (
    <div className="fp-shell fp-grain" data-testid="app-shell">
      <div
        className="relative z-10"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 7rem)" }}
      >
        <Outlet />
      </div>
      {showFab && <Fab onClick={() => setOpenAdd(true)} />}
      <BottomNav />
      <AddTransactionSheet open={openAdd} onOpenChange={setOpenAdd} />
    </div>
  );
}
